import { DotsThreeOutlineVertical } from "@phosphor-icons/react";
import {
  type ComponentProps,
  Fragment,
  type MouseEvent,
  type ReactNode,
} from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./Dropdown";

export interface IActionItem {
  content: ReactNode;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
  addSeparator?: boolean;
}

interface IActionMenuProps extends ComponentProps<typeof DropdownMenu> {
  label?: ReactNode;
  trigger?: ReactNode;
  items: IActionItem[];
}

export const ActionMenu = ({
  items,
  label,
  trigger,
  ...rest
}: IActionMenuProps) => {
  return (
    <DropdownMenu modal={false} {...rest}>
      <DropdownMenuTrigger>
        {trigger ?? (
          <DotsThreeOutlineVertical
            size={20}
            className="text-primary-300"
            weight="fill"
          />
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent className="z-[500000]">
        {label && <DropdownMenuLabel>{label}</DropdownMenuLabel>}
        {label && <DropdownMenuSeparator />}
        {items.map((item, index) => (
          <Fragment key={index}>
            <DropdownMenuItem onClick={item.onClick}>
              {item.content}
            </DropdownMenuItem>
            {item.addSeparator && <DropdownMenuSeparator />}
          </Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
